import { FunctionComponent, memo, useMemo } from 'react';
import {
  StoryCard,
  StoryCardPostContent,
  StoryCardPostContentBlockFields,
  StoryCardType,
} from '../../../services';
import { BlockTypes, optArrItem } from '../../../shared';
import { DetailsBlock } from '../DetailsBlock';
import { DetailsCardToBlock } from '../DetailsCardToBlock';

import classes from './DetailsBody.module.scss';

interface DetailsBodyProps {
  card: StoryCard;
  chatId?: number;
}

export const DetailsBody: FunctionComponent<DetailsBodyProps> = memo(({ card, chatId }) => {
  const { id: cardId, storyId, type, content, mentionedUsers } = card;

  const fullPostContentBlocks: StoryCardPostContentBlockFields[] = useMemo(() => {
    if (type !== StoryCardType.POST) {
      return [];
    }

    const { contentBlocks } = content as StoryCardPostContent;

    return [
      ...optArrItem(Boolean(mentionedUsers.length), {
        type: BlockTypes.mention,
        data: { mentionedUsers },
      }),
      ...contentBlocks,
    ];
  }, [content, mentionedUsers, type]);

  const details = useMemo(() => {
    if (Boolean(fullPostContentBlocks.length)) {
      return (
        <div className={classes['details-body']}>
          {fullPostContentBlocks.map((block, index) => (
            <DetailsBlock
              key={`${block.type}${index}`}
              block={block}
              storyId={storyId}
              cardId={cardId}
            />
          ))}
        </div>
      );
    }

    return <DetailsCardToBlock card={card} chatId={chatId} />;
  }, [card, cardId, chatId, fullPostContentBlocks, storyId]);

  return <>{details}</>;
});
